import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import BankerContMain from "presentation/view/container/Banker/BankerContMain";

CommonEntrypoint(<BankerContMain />)